<template>
  <div class="user">
    <h4>{{ user.first_name}} {{ user.last_name}} <span>/ {{ _[user.role_id] }}</span></h4>
    <span class="button" @click="logoutUser">
      <font-awesome-icon :icon="['fad', 'sign-out-alt']" />
      {{ _.logout }}
    </span>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  computed: {
    ...mapGetters(['user'])
  },
  methods: {
    ...mapActions(['logoutUser']),
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/variables.scss';
.user {
  > h4 {
    > span {
      color: lighten($primary-color, 60%);
    }
  }
  > span {
    display: inline-block;
    padding: 0 0 12px 12px;
    // font-weight: bold;
    text-decoration: none;
    color: $primary-color;
    &.button {
      opacity: .4;
      cursor: pointer;
      &:hover, &.router-link-active {
        opacity: 1;
      }
    }
    > svg {
      font-size: 1rem;
      line-height: 1rem;
      margin-bottom: -2px;
      margin-right: 2px;
    }
  }
}
</style>